import(/* webpackMode: "eager" */ "/home/high/your-token-art-crazy-v3/src/app/page.tsx");
